const demo = document.querySelector("[data-ai-demo]");

// Text typed by the demo. FR/DE come from the page dictionary
// (js/i18n-platform.js, platform.demo.new_conversation / step0-4), so the
// build can also write them into the static /fr/ and /de/ pages.
const DEMO_EN = {
  "newConversation": "New conversation",
  "steps": {
    0: "Create an MCP connection to https://platform.forsytenergy.com/mcp",
    1: "Let me inspect Forsyt's public integration.",
    2: "Done. Forsyt is connected. I can now search its insights, check market coverage and retrieve BESS reference data.",
    3: "Show me the Forsyt BESS Reference levels for France in 2026.",
    4: "Here are the BESS revenue levels for Central, P10 and P90 for France. The Central case reached its 2026 high in April at €355k/MW/year."
  }
};
const demoStrings = () => {
  const dict = (window.FORSYT_PAGE_I18N || {})[window.forsytLang] || {};
  const steps = {};
  for (const n of Object.keys(DEMO_EN.steps)) {
    steps[n] = dict["platform.demo.step" + n] || DEMO_EN.steps[n];
  }
  return { newConversation: dict["platform.demo.new_conversation"] || DEMO_EN.newConversation, steps };
};

if (demo) {
  const messages = [...demo.querySelectorAll("[data-step]")];
  const title = demo.querySelector("[data-ai-title]");
  const chart = demo.querySelector("[data-ai-chart]");
  const replay = demo.querySelector("[data-ai-replay]");
  const log = demo.querySelector(".ai-demo-log");
  let runId = 0;
  let hasPlayed = false;

  const wait = (milliseconds, currentRun) =>
    new Promise((resolve) => {
      window.setTimeout(() => resolve(currentRun === runId), milliseconds);
    });

  const typeText = async (element, text, currentRun) => {
    element.textContent = "";
    element.classList.add("ai-cursor");
    for (let index = 0; index < text.length; index += 1) {
      if (currentRun !== runId) return false;
      element.textContent += text[index];
      if (index % 8 === 0 && log) log.scrollTop = log.scrollHeight;
      await new Promise((resolve) => window.setTimeout(resolve, 14));
    }
    element.classList.remove("ai-cursor");
    if (log) log.scrollTop = log.scrollHeight;
    return currentRun === runId;
  };

  const resetDemo = () => {
    runId += 1;
    messages.forEach((message) => {
      message.classList.remove("is-visible");
      const paragraph = message.querySelector("p");
      if (paragraph) {
        paragraph.textContent = "";
        paragraph.classList.remove("ai-cursor");
      }
      message
        .querySelectorAll(".ai-tool-steps span")
        .forEach((step) => step.classList.remove("is-visible"));
    });
    chart?.classList.remove("is-visible");
    replay?.classList.remove("is-visible");
    if (log) log.scrollTop = 0;
    if (title) title.textContent = demoStrings().newConversation;
    return runId;
  };

  const revealMessage = async (message, currentRun) => {
    message.classList.add("is-visible");
    if (message.classList.contains("assistant") && title) {
      title.textContent = "Forsyt MCP";
    }
    const paragraph = message.querySelector("p");
    if (paragraph) {
      const completed = await typeText(
        paragraph,
        demoStrings().steps[message.dataset.step] || "",
        currentRun,
      );
      if (!completed) return false;
    }
    for (const step of message.querySelectorAll(".ai-tool-steps span")) {
      if (!(await wait(380, currentRun))) return false;
      step.classList.add("is-visible");
      if (log) log.scrollTop = log.scrollHeight;
    }
    return true;
  };

  const playDemo = async () => {
    const currentRun = resetDemo();
    for (const message of messages) {
      if (!(await wait(450, currentRun))) return;
      if (!(await revealMessage(message, currentRun))) return;
      if (!(await wait(520, currentRun))) return;
    }
    chart?.classList.add("is-visible");
    if (log) log.scrollTo({ top: log.scrollHeight, behavior: "smooth" });
    if (!(await wait(1900, currentRun))) return;
    replay?.classList.add("is-visible");
  };

  replay?.addEventListener("click", playDemo);

  const observer = new IntersectionObserver(
    (entries) => {
      if (!hasPlayed && entries.some((entry) => entry.isIntersecting)) {
        hasPlayed = true;
        playDemo();
        observer.disconnect();
      }
    },
    { threshold: 0.35 },
  );

  observer.observe(demo);

  // Language switch: update the idle title, or replay in the new language.
  document.addEventListener("forsyt:langchange", () => {
    if (hasPlayed) playDemo();
    else if (title) title.textContent = demoStrings().newConversation;
  });
  if (title) title.textContent = demoStrings().newConversation;
}
